import { Plural } from '@lingui/react/macro';
import { Card, CardContent, cn } from '@pantry/ui';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

/**
 * Collapsible group for items in a storage location.
 */
export function LocationGroup({
  title,
  icon,
  itemCount,
  isExpanded,
  onToggle,
  muted = false,
  children,
}: {
  title: string;
  icon: string;
  itemCount: number;
  isExpanded: boolean;
  onToggle: () => void;
  muted?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Card className={cn('overflow-hidden', muted && 'border-dashed border-muted-foreground/30')}>
      <button
        onClick={onToggle}
        className="flex w-full items-center justify-between p-4 text-left hover:bg-muted/30 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div
            className={cn(
              'flex h-10 w-10 items-center justify-center rounded-lg text-xl',
              muted ? 'bg-muted/50' : 'bg-primary/10'
            )}
          >
            {icon}
          </div>
          <div>
            <h3
              className={cn(
                'font-heading font-semibold',
                muted ? 'text-muted-foreground' : 'text-foreground'
              )}
            >
              {title}
            </h3>
            <p className="text-sm text-muted-foreground">
              <Plural value={itemCount} one="# item" other="# items" />
            </p>
          </div>
        </div>
        <div
          className={cn(
            'flex h-8 w-8 items-center justify-center rounded-lg transition-colors',
            isExpanded ? 'bg-muted' : 'bg-transparent'
          )}
        >
          {isExpanded ? (
            <ChevronDownIcon className="h-5 w-5 text-muted-foreground" />
          ) : (
            <ChevronRightIcon className="h-5 w-5 text-muted-foreground" />
          )}
        </div>
      </button>
      {isExpanded && (
        <CardContent className="pt-0 pb-4 border-t border-border/50">{children}</CardContent>
      )}
    </Card>
  );
}
